<template>
  <div v-if="note" class="tms-ownership-note" :title="note.title">
    <span class="ton-icon">ⓘ</span>
    <span class="ton-text"><strong>{{ note.title }}.</strong> {{ note.text }}</span>
    <KbHint article="ip-carrier" label="Подробнее" />
  </div>
</template>

<script>
import { computed } from 'vue'
import { tmsOwnershipNote } from '@/pages/trip/helpers/tmsOwnership.mjs'
import KbHint from '@/components/KbHint.vue'

export default {
  name: 'TmsOwnershipNote',
  components: { KbHint },
  props: ['executor'],
  setup(props) {
    const note = computed(() => tmsOwnershipNote(props.executor))
    return { note }
  },
}
</script>

<style scoped>
.tms-ownership-note {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin: 8px 0;
  padding: 8px 12px;
  border-radius: 8px;
  background: #eef4ff;
  border: 1px solid #a9c1f5;
  color: #1e3a72;
  font-size: 13px;
  line-height: 1.4;
}
.ton-icon { font-weight: 700; }
</style>
